<template>
  <c-base-dialog v-model="isShow" :option="popOption" @close="$emit('close')">
    <template slot="body">
      <div :class="['dialog', 'dialog--default', !isMobile ? 'dialog--pc' : '']">
        <div class="dialog-content">
          <div class="win-prize-body">
            <ul class="win-prize-body-title" :style="winPrizeRecordTitleBgStyle">
              <li class="win-prize-body-title-name" :style="prizeRecordItemTitleCommonStyle">
                红包金额
              </li>
              <li class="win-prize-body-title-time" :style="prizeRecordItemTitleCommonStyle">
                时间
              </li>
              <li class="win-prize-body-title-action" :style="prizeRecordItemTitleCommonStyle">
                发放状态
              </li>
            </ul>
            <template v-if="list.length > 0">
              <!--              // 滚动窗口-->
              <div class="win-prize-body-record-scroll-window" :style="PrizeBodyRecordScrollStyle">
                <ul class="win-prize-body-record" :style="winPrizeRecordBottomBorderStyle" v-for="(item, index) of list"
                  :key="index">
                  <li ref="textDecorationPopups" class="win-prize-body-record-name">
                    <span :style="prizeRecordItemCommonStyle">{{ `红包*${item.amount / 100} 元` }}</span>
                  </li>
                  <li class="win-prize-body-record-time" :style="prizeRecordItemCommonStyle">{{ item.released_at }}
                  </li>
                  <li
                    class="win-prize-body-record-action"
                    :style="prizeRecordItemCommonStyle"
                    @click="showDetail(item)">
                    <span :class="downLine(item)">{{item.status_text}}</span>
                  </li>
                </ul>
              </div>

            </template>

            <template v-if="list.length === 0">
              <div class="win-prize-body-empty-record-msg" :style="prizeRecordItemCommonStyle">
                还没获得奖品，快去参加活动吧
              </div>
            </template>
            <template v-if="list.length > 0">
              <div class="win-prize-body-page" v-if="Math.ceil(page.total / pageSize) >= 1">
                <span @click="page.current > 1 && page.current--" :style="pageSizeItemCommonStyle">上一页</span>
                <span class="win-prize-body-page-num" :style="pageSizeItemCommonStyle">
                  {{ page.current }}/{{ Math.ceil(page.total / pageSize) }}</span>
                <span @click="page.current < page.total / pageSize && page.current++"
                  :style="pageSizeItemCommonStyle">下一页</span>
              </div>
            </template>
          </div>
        </div>

      </div>
    </template>
  </c-base-dialog>
</template>

<script>
import { ClaimRedpacketRecord } from '../apis';
import CDialog from '../base-dialog';
import Vue from 'vue';

export default {
  name: 'package-claim-red-record',
  components: {
    [CDialog.name]: CDialog,
  },
  props: {
    gameCode: String,
    params: Object,
    fontColor: {
      type: String,
      default: '#000',
    },
    option: Object,
    pageSize: Number,
  },
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      list: [],
      page: {
        current: 1,
        total: 0,
      },
      isShow: true,
      popupsIndex: -1, // 弹出层下标
    };
  },
  computed: {
    PrizeBodyRecordScrollStyle() {
      const overflow = !this.isMobile ? 'visible' : 'hidden';
      return {
        overflowY: this.list.length <= 6 ? overflow : 'scroll',
      };
    },
    winPrizeRecordBottomBorderStyle() {
      return {
        borderBottom: `${!this.isMobile
          ? '0px' : '0.02rem'} solid ${this.popStyleTextRgba.color10}`,
      };
    },
    winPrizeRecordTitleBgStyle() {
      return { backgroundColor: !this.isMobile ? '#F7F9FA' : this.popStyleTextRgba.color10 };
    },
    pageSizeItemCommonStyle() {
      return {
        color: !this.isMobile ? '#8E8E93' : this.popStyleTextRgba.color100,
      };
    },
    prizeRecordItemTitleCommonStyle() {
      return {
        color: !this.isMobile ? '#242424' : this.popStyleTextRgba.color100,
      };
    },
    prizeRecordItemCommonStyle() {
      return {
        color: !this.isMobile ? '#242424' : this.popStyleTextRgba.color100,
        '--borderColor': !this.isMobile ? '1px solid #242424' : `1px solid${this.popStyleTextRgba.color100}`,
      };
    },
    popStyleTextRgba() {
      const hexToRgba = (hex, opacity) => `rgba(${parseInt(`0x${hex.slice(1, 3)}`, 16)}
      ,${parseInt(`0x${hex.slice(3, 5)}`, 16)},${parseInt(`0x${hex.slice(5, 7)}`, 16)},${opacity})`;
      return {
        color100: this.popTextStyle.color,
        color50: hexToRgba(this.popTextStyle.color, 0.5),
        color80: hexToRgba(this.popTextStyle.color, 0.8),
        color10: hexToRgba(this.popTextStyle.color, 0.10),
      };
    },
    popTextStyle() {
      const { dialogStyle = {} } = this.option;
      let color = dialogStyle?.color;
      if (!color) {
        color = Vue.prototype?.$storeInstance?.getters?.dialogConfig?.dialogStyle?.color || '#000000';
      }
      return { color };
    },
    popOption() {
      // 用户配置
      console.log('---  user  setting  popConfig ---- ', this.option);
      // 读取传入width, height
      const { titleStyle = {}, dialogStyle: dialogStyleOption = {}, width, height } = this.option || {};
      // 新增标题颜色
      if (!titleStyle.color) {
        titleStyle.color = this.popTextStyle.color;
      }
      // eslint-disable-next-line max-len, vue/max-len
      const { dialogStyle = {}, closeLocation } = Vue.prototype?.$storeInstance?.getters?.dialogConfig ?? {};
      let { closeStyle = {} } = Vue.prototype?.$storeInstance?.getters?.dialogConfig ?? {};
      let bgImageStyle = '';
      const bgImageReg = /(https:|http:)?\/\/[^\s]*$/;
      if (!bgImageStyle && dialogStyleOption.backgroundImage && bgImageReg.test(dialogStyleOption.backgroundImage)) {
        bgImageStyle = dialogStyleOption.backgroundImage;
      }
      if (!bgImageStyle && dialogStyle.backgroundImage && bgImageReg.test(dialogStyle.backgroundImage)) {
        bgImageStyle = dialogStyle.backgroundImage;
      }
      if (!closeStyle.backgroundImage || !bgImageReg.test(closeStyle.backgroundImage)) {
        closeStyle = '';
      }
      const popConfig = {
        header: '红包领取记录',
        titleStyle: { fontSize: '0.40rem', borderBottom: 'none', fontWeight: 500, ...titleStyle },
        close: true,
        closeLocation: !this.isMobile ? 'top-right' : closeLocation,
        height,
        width,
        confirm: false,
        footer: false,
        closeStyle: !this.isMobile ? {
          backgroundImage: 'url(https://act.supercore.qq.com/activity/supercore/14161/be052f80d9bba6a5888eb12b6b045ffa.png)',
        } : closeStyle,
        dialogStyle: Object.assign(
          {},
          {
            color: this.popTextStyle.color,
            backgroundImage: bgImageStyle,
          },
        ),
      };
      // 设置默认的width, height
      if (!popConfig.width) {
        popConfig.width = '6.68rem';
      }
      if (!popConfig.height) {
        popConfig.height = '7.2rem';
      }
      // 如果传入高度低于  7.2rem 则强制用 7.2rem
      if (parseFloat(popConfig.height) < 7.2) {
        popConfig.height = '7.2rem';
      }
      console.log('--------------------  final reward window popConfig  ------------= 11', popConfig);
      return popConfig;
    },
    downLine() {
      return item => ((item.status === 9) ? 'desc-glide' : '');
    },
  },
  watch: {
    'page.current'() {
      this.freshList();
    },
  },
  async mounted() {
    this.freshList();
    if (!this.isMobile && this.list.length > 0) {
      const that = this;
      document.addEventListener('click', (e) => {
        if (!that.$refs?.textDecorationPopups[that.popupsIndex]?.contains(e.target)) {
          that.popupsIndex = -1;
        }
      });
    }
  },
  destroyed() {
    if (!this.isMobile) {
      const that = this;
      document.removeEventListener('click', (e) => {
        if (!that.$refs?.textDecorationPopups[that.popupsIndex]?.contains(e.target)) {
          that.popupsIndex = -1;
        }
      });
    }
  },
  methods: {
    async freshList() {
      if (this.$isInEditor) {
        this.list = new Array(this.pageSize).fill({
          amount: 10, // 发放金额
          released_at: '2023-10-11 16:55:26', // 发放时间
          status: 0, // 状态，0-末知，1-待发放，2-发放中，3-发放失败，4-已发放，5-已领取，6-退款中 7-已退款，8-发放失败
          reason: '网络异常', // 发放失败原因
        });
        this.page.total = 11;
        return;
      }
      const res = await ClaimRedpacketRecord.getClaimRedPakcetRecords({
        ...this.params,
        page_size: this.pageSize,
        page: this.page.current,
      });

      if (res.ret === 0) {
        this.list = res?.data?.list?.list || [];
        this.page.total = res?.data?.list?.total;
        console.log('list,total=', this.list, this.page.total);
      }
    },
    showDetail(item) {
      const { status } = item;
      if (Number(status) === 9) {
        this.alert(item.reason);
      }
    },
  },
};
</script>

<style scoped>
.dialog {
  font-size: 0.2rem;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 7.2rem;
  position: absolute;
}

.dialog--pc {
  font-size: 20px;
  width: 500px;
  width: 720px;
  display: block;
  height: 100%;
  position: static;
}

.dialog-content {
  text-align: center;
  margin: 0 auto;
}

.dialog--default .win-prize-body {
  width: 5.6rem;
  height: 4.9rem;
}

.dialog--default .win-prize-body-title {
  width: 5.6rem;
  height: 0.56rem;
  line-height: 0.56rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  list-style: none;
  text-align: center;

}

.dialog--default .win-prize-body-title .win-prize-body-title-name {
  width: 2rem;
}

.dialog--default .win-prize-body-title .win-prize-body-title-time {
  width: 2rem;
}

.dialog--default .win-prize-body-title .win-prize-body-title-action {
  width: 1.6rem;
}

.dialog--default .win-prize-body-record .win-prize-body-record-name {
  width: 2rem;
}

.dialog--default .win-prize-body-record .win-prize-body-record-time {
  width: 2rem;
  font-size: 0.22rem;

}

.dialog--default .win-prize-body-record .win-prize-body-record-action {
  width: 1.6rem;
}
.dialog--default .win-prize-body-record .win-prize-body-record-action .desc-glide {
  border-bottom: var(--borderColor);
}

.win-prize-body-record .text-decoration {
  text-decoration: underline;
  white-space: nowrap;
}


.dialog--default .win-prize-body-title li {
  font-size: 0.24rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
}

.win-prize-body-record-scroll-window {
  /* 高度 (0.65 + 0.02（边框） ) *  6 */
  height: 4.02rem;
  max-height: 4.02rem;
}

.dialog--default .win-prize-body-record {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  list-style: none;
  justify-content: flex-start;
}

.dialog--default .win-prize-body-record li {
  width: 5.6rem;
  height: 0.65rem;
  line-height: 0.65rem;
  font-size: 0.24rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
  text-align: center;
  list-style: none;

}

.dialog--default .win-prize-body-empty-record-msg {
  letter-spacing: 1px;
  font-size: 0.24rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
  margin: 0 auto;
  margin-top: 40%;
}

.dialog--default .win-prize-body-page {
  font-size: 0.24rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
  margin-top: 0.2rem;
}

.dialog--default .win-prize-body-page .win-prize-body-page-num {
  margin: 0 0.7rem;
}

.win-prize-body-record-time {
  white-space: nowrap;
}

/* pc */
.dialog--pc .win-prize-body {
  width: 100%;
  height: 100%;
  padding: 0 24px;
}

.dialog--pc .win-prize-body-title {
  width: 100%;
  height: 50px;
  line-height: 30px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  list-style: none;
  text-align: center;
  border-radius: 6px;
}

.dialog--pc .win-prize-body-title li {
  font-style: normal;
  line-height: 50px;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0px;
  text-align: left;
}

.dialog--pc .win-prize-body-record {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: left;
  margin: 12px 0;
}

.dialog--pc .win-prize-body-title .win-prize-body-title-name {
  margin-left: 10px;
  width: 150px;
}

.dialog--pc .win-prize-body-title .win-prize-body-title-time {
  margin-left: 10px;
  width: 180px;
}

.dialog--pc .win-prize-body-title .win-prize-body-title-action {
  margin-left: 10px;
  width: 100px;
}

.dialog--pc .win-prize-body-record .win-prize-body-record-name {
  margin-left: 10px;
  width: 150px;
  position: relative;
  display: inline-block;
}

.dialog--pc .win-prize-body-record .win-prize-body-record-time {
  margin-left: 10px;
  font-size: 14px;
  width: 180px;
}

.dialog--pc .win-prize-body-record .win-prize-body-record-action {
  margin-left: 10px;

  width: 100px;
}

.dialog--pc .win-prize-body-empty-record-msg {
  letter-spacing: 1px;
  font-family: PingFang SC;
  font-style: normal;
  margin: 0 auto;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: center;
  margin-top: 40%;
  margin-bottom: 40%;
}

.dialog--pc .win-prize-body-record li {
  width: 560px;
  height: 32px;
  line-height: 32px;
  font-weight: 400;
  font-family: PingFang SC;
  font-style: normal;
  text-align: left;
  list-style: none;
  font-family: PingFang SC;
  font-size: 14px;
  letter-spacing: 0px;
  text-align: left;
}

.dialog--pc .win-prize-body-record-scroll-window {
  /* 高度 (0.65 + 0.02（边框） ) *  6 */
  height: 100%;
  border-bottom: 1px solid #EBEBEB;
  padding-bottom: 12px;
  max-height: 402px;
}

.dialog--pc .win-prize-body-page {
  font-size: 14px;
  font-weight: 400;
  font-family: PingFang SC;
  font-style: normal;
  margin: 20px 0;
}

.dialog--pc .win-prize-body-page .win-prize-body-page-num {
  margin: 0 70px;
}

.dialog--pc .win-prize-body-record .text-decoration {
  text-decoration: underline;
  display: inline-block;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 135px;
  color: #1D3F7C;
}

.dialog--pc .text-decoration-popups {
  width: 1366px;
  max-width: 452px;
  max-height: 100px;
  min-width: 200px;
  background-color: #000;
  padding: 5px 10px;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  border-radius: 15px;
  bottom: 35px;
  z-index: 99;
  animation: pop-open 0.3s 1;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #fff;
  box-sizing: content-box;
  display: inline-block;
}

.dialog--pc .text-decoration-popups-pointer {
  position: absolute;

  width: 0px;
  height: 0px;
  border: 9px solid transparent;
  /* border: 18px solid rgba(0,0,0,0.7); */
  border-bottom-color: transparent;
  border-top-color: rgba(0, 0, 0, 0.6);
  border-left-color: transparent;
  border-right-color: transparent;
  bottom: -18px;
  left: 80px;
  transform: translateX(-50%);
}

.dialog--pc .text-decoration-popups p {
  /* max-width: 452px;
  min-width: 200px;
  max-height: 100px; */
  width: fit-content;
  display: block;
  /* height: 100px; */
  color: #fff;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  z-index: 99;
}

@keyframes pop-open {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes pop-close {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
